module.exports = __webpack_public_path__ + "img/metallics.4b461ce1.jpg";